import React from 'react';
import { Icon } from '@chakra-ui/icons';
import { Color } from 'src/theme/color';

export enum Type {
	DONE,
	UNDONE,
}

export const IconCheckmark = ({ type = Type.UNDONE }: { type?: Type }) => {
	return (
		<Icon
			width="16px"
			height="auto"
			viewBox="0 0 16 15"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.4209 6.89536L7.63149 9.10596L15.0001 1.7373"
				stroke={type === Type.UNDONE ? '#333131' : Color.ACTION}
				strokeWidth="1.16671"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M14.2636 7.63179V12.7898C14.2636 13.1807 14.1083 13.5556 13.8319 13.8319C13.5556 14.1083 13.1807 14.2636 12.7898 14.2636H2.47373C2.08287 14.2636 1.70802 14.1083 1.43165 13.8319C1.15527 13.5556 1 13.1807 1 12.7898V2.47373C1 2.08287 1.15527 1.70802 1.43165 1.43165C1.70802 1.15527 2.08287 1 2.47373 1H10.5792"
				stroke={type === Type.UNDONE ? '#333131' : 'backgroundLight'}
				strokeWidth="1.16671"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Icon>
	);
};
